import Circles from './Circles';
import Lines from './Lines';
import Paths from './Paths';

export default {
  Circles,
  Lines,
  Paths,
};



// WEBPACK FOOTER //
// ./src/index.js